import {
  Datagrid,
  EditButton,
  StateCollectionInput,
  useFieldLabel,
} from "ra-friendsofbabba";
import { List as RaList, TextField, usePermissions } from "react-admin";
import React, { useMemo } from "react";

import Actions from "../component/list/Actions";
import Empty from "../component/list/Empty";
import ExportButton from "./buttons/ExportButton";
import { ExportMenuButton } from "../component/button";
import Filters from "./Filters";
import ReferencePeriodField from "./fields/ReferencePeriodField";
import { UserField } from "../component/field";

const List = (props) => {
  const { loaded, permissions } = usePermissions();
  const { isAdmin, isTro, isManager, isMir, additionalProps } = useMemo(() => {
    const isAdmin = loaded && permissions(["admin"]);
    const isTro = loaded && permissions(["tro"]);
    const isMir = loaded && permissions(["mir"]);
    const isManager = loaded && permissions(["manager"]);
    const additionalProps = isAdmin ? {} : { bulkActionButtons: false };
    return { isAdmin, isTro, isMir, isManager, additionalProps };
  }, [loaded, permissions]);

  const getLabel = useFieldLabel({ ...props });
  return (
    <RaList
      {...props}
      {...additionalProps}
      actions={
        <Actions canExport={false}>
          {(isAdmin || isTro || isManager | isMir) && (
            <ExportMenuButton choices={["tro.xlsx"]} />
          )}
        </Actions>
      }
      filters={<Filters />}
      empty={<Empty canCreate={isAdmin || isMir || isManager} />}
      sort={{ field: "SubstitutiveDeclarations.id", order: "ASC" }}
      exporter={false}
    >
      <Datagrid rowClick={"edit"}>
        <TextField
          source="id"
          label="#ID"
          sortBy="SubstitutiveDeclarations.id"
        />
        <UserField
          label={getLabel("user_id")}
          source="user.name"
          sortBy="UserProfiles.name"
        />
        <ReferencePeriodField
          label={getLabel("period")}
          source="technical_project"
          sortBy="number"
        />
        <StateCollectionInput
          source="state"
          label={getLabel("state")}
          readonly={!isAdmin}
          admin={isAdmin}
          sortable={false}
        />
        <EditButton />
        <ExportButton isAdmin={isAdmin} />
      </Datagrid>
    </RaList>
  );
};
export default List;
